
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEOMetadata from '@/components/SEOMetadata';
import MobileHeroSection from '@/components/mobile/MobileHeroSection';
import MobileOfferingsSection from '@/components/mobile/MobileOfferingsSection';
import MobileProcessSection from '@/components/mobile/MobileProcessSection';
import MobileTargetSection from '@/components/mobile/MobileTargetSection';
import MobileCTASection from '@/components/mobile/MobileCTASection';

const MobileSolutions = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Mobile Network Solutions",
    "provider": {
      "@type": "Organization",
      "name": "NEXX TELECOM"
    },
    "description": "Mobile network solutions and mobile proxy services for businesses. Secure mobile connectivity and mobile IP rotation services.",
    "serviceType": "Mobile Network Solutions",
    "areaServed": "Global"
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOMetadata
        title="Mobile Network Solutions | Mobile Proxies | NEXX"
        description="Comprehensive mobile network solutions including mobile proxies, mobile IP rotation, and secure mobile connectivity for businesses worldwide."
        keywords="mobile network solutions, mobile proxies, mobile IP rotation, mobile connectivity, mobile network services, 4G proxies, 5G proxies"
        canonical="https://nexx.net/mobile-solutions"
        structuredData={structuredData}
      />
      <Header />
      <main>
        <MobileHeroSection />
        <MobileOfferingsSection />
        <MobileProcessSection />
        <MobileTargetSection />
        <MobileCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default MobileSolutions;
